import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Header from "../../components/header/Header";
import ProgressBar from "../../components/progressBar/ProgressBar";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { addToCart, removeFromCart } from "../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import { updateBusinessRequest } from "../../redux/actions/RequestActions";
import Swal from "sweetalert2";
import Loader from "../../components/loader/Loader";
import { removeFromServiceList } from "../../redux/actions/ServiceListActions";

// Validation schema
const validationSchema = Yup.object({
  businessName: Yup.string().required("Le nom de l'entreprise est requis"),
});

function EditHaveBusinessName() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const { businessCreationRequest } = useSelector((state) => state.request);
  const [submitting, setSubmitting] = useState(false);
  const servicesList = useSelector((state) => state.serviceList.services);
  const [name, setName] = useState(false);

  const handleCallback = async ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      await dispatch(removeFromCart("businessName"));
      await dispatch(removeFromServiceList("name_registration"));
      await dispatch(
        addToCart({
          businessName: name,
        })
      );

      navigate(-2, { replace: true });
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <Loader isLoading={submitting} />
      <ProgressBar steps={steps} currentStep={currentStep} />

      {/* Title Section */}
      <div className="container mt-4 mb-4 text-center">
        <h4 className="text-2xl font-semibold">
          Quel est le <span style={{ color: "#FF5500" }}>nom</span> pour votre{" "}
          {cart?.businessType} ?
        </h4>
      </div>

      {/* Form Section */}
      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{
            businessName: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            setSubmitting(true);
            setName(values.businessName);
            const updatedServicesList = servicesList.filter(
              (service) => service.code !== "name_registration"
            );
            await dispatch(
              updateBusinessRequest(
                user.token,
                businessCreationRequest.reference,
                {
                  businessName: values.businessName,
                  services: [...updatedServicesList],
                },
                handleCallback
              )
            );
          }}
        >
          {({ setFieldValue, errors, touched, values }) => (
            <Form className="w-100" style={{ maxWidth: "500px" }}>
              <div className="mb-3">
                <Field
                  name="businessName"
                  className="form-control"
                  placeholder="Nom de l'entreprise"
                  style={{ height: "50px" }}
                />
                {errors.businessName && touched.businessName && (
                  <div className="text-danger">{errors.businessName}</div>
                )}
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Confimer
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default EditHaveBusinessName;
